import moment from 'moment/moment';

import { Audience, DocumentType } from '~/data/documents/types';

export type DocumentsEntry = {
  id: number;
  employeeId?: number;
  type: string;
  created?: Date;
  modified?: Date;
  name: string;
  description: string;
  expires?: Date;
  approval: string;
  attachment?: File;
  ownerId?: number;
  ownerType?: string;
  readOnly?: boolean;
  fileSize?: number;
  fileHash?: string;
  audience?: Audience;
};

export const convertDocumentTypeToDocumentsEntry = (
  data: DocumentType,
): DocumentsEntry => {
  const {
    fDocumentId,
    fDocumentDocType,
    fDocumentCreated,
    fDocumentModified,
    fDocumentName,
    fDocumentDescription,
    fDocumentExpirationDate,
    fDocumentApprovalStatus,

    fDocumentAttachment,

    fDocumentEmpId,
    fDocumentOwnerId,
    fDocumentOwnerType,
    fDocumentDocReadOnly,
    fDocumentSize,
    fDocumentSha1Hash,
    fDocumentAudience,
  } = data;

  return {
    id: fDocumentId,
    employeeId: fDocumentEmpId,
    type: fDocumentDocType,
    created: !!fDocumentCreated ? moment(fDocumentCreated).toDate() : undefined,
    modified: !!fDocumentModified
      ? moment(fDocumentModified).toDate()
      : undefined,
    name: fDocumentName ?? '',
    description: fDocumentDescription ?? '',
    expires: !!fDocumentExpirationDate
      ? moment(fDocumentExpirationDate).toDate()
      : undefined,
    approval: fDocumentApprovalStatus ?? '',
    attachment: fDocumentAttachment,
    ownerId: fDocumentOwnerId,
    ownerType: fDocumentOwnerType,
    readOnly: fDocumentDocReadOnly,
    fileSize: fDocumentSize,
    fileHash: fDocumentSha1Hash,
    audience: fDocumentAudience,
  };
};

export const convertDocumentsEntryToSubmission = (
  tableRow: DocumentsEntry,
  isUpdate?: boolean,
): DocumentType => {
  const {
    id,
    type,
    created,
    name,
    description,
    expires,
    approval,
    attachment,
    employeeId,
    ownerId,
    ownerType,
    readOnly,
    fileSize,
    fileHash,
    audience,
  } = tableRow;

  const getDocumentDate = (date: Date) =>
    moment(date).format('YYYY-MM-DD').toString();

  return {
    fDocumentId: id,
    fDocumentDocType: type,
    fDocumentCreated: !isUpdate && created ? getDocumentDate(created) : '',
    fDocumentModified: getDocumentDate(new Date()),
    fDocumentName: name,
    fDocumentDescription: description,
    fDocumentExpirationDate: expires ? getDocumentDate(expires) : '',
    fDocumentApprovalStatus: approval,
    fDocumentAttachment: attachment,
    fDocumentEmpId: employeeId,
    fDocumentOwnerId: ownerId,
    fDocumentOwnerType: ownerType,
    fDocumentDocReadOnly: readOnly,
    fDocumentSize: fileSize,
    fDocumentSha1Hash: fileHash,
    fDocumentAudience: audience,
  };
};

export const documentSubmissionToFormData = (eq: DocumentType): FormData => {
  const convertDateString = (date: string) => {
    return moment(date).format('YYYY-MM-DD');
  };

  const formData = new FormData();
  formData.append('fDocumentDocType', eq.fDocumentDocType);
  formData.append(
    'fDocumentExpirationDate',
    eq.fDocumentExpirationDate
      ? convertDateString(eq.fDocumentExpirationDate)
      : '',
  );
  formData.append(
    'fDocumentCreated',
    eq.fDocumentCreated ? eq.fDocumentCreated : '',
  );
  formData.append(
    'fDocumentModified',
    eq.fDocumentModified ? convertDateString(eq.fDocumentModified) : '',
  );
  formData.append('fDocumentDescription', eq.fDocumentDescription || '');
  formData.append(
    'fDocumentId',
    eq.fDocumentId ? eq.fDocumentId.toString() : '-1',
  );
  formData.append('fDocumentName', eq.fDocumentName || '');
  if (eq.fDocumentAttachment) {
    formData.append('file', eq.fDocumentAttachment);
  }
  return formData;
};
